var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStop = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 280 280"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M215.452 44.05H64.688c-11.353.005-20.555 9.207-20.56 20.56v150.78c.005 11.353 9.207 20.555 20.56 20.56h150.764c11.352-.005 20.554-9.207 20.56-20.56V64.61c-.006-11.353-9.208-20.555-20.56-20.56"
})));
export default SvgStop;